<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Report" sub-title="Nilai Peserta Berdasarkan Materi" @back="back">
            <common-training-header :withLocation="true" />
        </a-page-header>

        <a-row style="margin: 24px 0;">
            <a-col class="text-right">
                <download-excel :data="excel" name="average-exam-growth.xls">
                    <a-button :loading="loading" type="primary">Download <a-icon type="cloud-download" /> </a-button>
                </download-excel>
            </a-col>
        </a-row>

        <a-card type="inner" size="small">
            <a-skeleton :loading="loading" active>
                <a-table class="pcp-table" :dataSource="tableData" rowKey="id" :pagination="false" :rowClassName="(r) => r.is_heading ? 'row-heading' : null" bordered>
                    <a-table-column key="title" title="Materi Pelatihan" className="align-center text-small text-left">
                        <template slot-scope="record">
                            <template v-if="record.is_heading"><strong>{{ record.name }}</strong></template>
                            <template v-else>{{ record.name }}</template>
                        </template>
                    </a-table-column>
                    <a-table-column key="inspirator" title="Inspirator" className="align-center text-small text-left">
                        <div slot-scope="record" v-if="! record.is_heading">
                            {{ record.inspirator.name }}
                        </div>
                    </a-table-column>
                    <a-table-column-group>
                        <span slot="title">Rata-rata Nilai Ujian</span>
                        <a-table-column :width="200" key="avg_pre_test" title="Pre Test" className="align-center text-center">
                            <template slot-scope="record" v-if="! record.is_heading">
                                <strong> {{ record.avg_pre_test ? parseFloat(record.avg_pre_test).toFixed(2) :  '-' }}</strong>
                            </template>
                        </a-table-column>
                        <a-table-column :width="200" key="avg_post_test" title="Post Test" className="align-center text-center">
                            <template slot-scope="record" v-if="! record.is_heading">
                                <strong> {{ record.avg_post_test ? parseFloat(record.avg_post_test).toFixed(2) : '-' }}</strong>
                            </template>
                        </a-table-column>
                    </a-table-column-group>
                    <a-table-column :width="200" key="result" title="Growth" className="align-center text-center">
                        <template slot-scope="record" v-if="! record.is_heading">
                            <strong> {{ record.growth ? record.growth + " %" : "-" }}</strong>
                        </template>
                    </a-table-column>
                </a-table>
            </a-skeleton>
        </a-card>
    </div>
</template>
<script>
export default {
    computed: {
        excel() {
            let data = []
            let vm = this
            let category = null

            if (this.loading)
                return data

            this.tableData.forEach(function(item) {
                if (item.is_heading) {
                    category = item.name
                } else {
                    data.push({
                        category: category,
                        material: item.name,
                        inspirator: item.inspirator.name,
                        avg_pre_test: item.avg_pre_test ? parseFloat(item.avg_pre_test).toFixed(2) : "-",
                        avg_post_test: item.avg_post_test ? parseFloat(item.avg_post_test).toFixed(2) : "-",
                        growth: item.growth ? item.growth + "%" : "-"
                    })
                }
            })

            return data
        },
        tableData() {
            let data = []
            if (this.loading)
                return data

            let num = 0

            Object.values(this.items).forEach(function (item) {
                data.push({
                    id: num++,
                    is_heading: true,
                    name: item.category
                })

                item.materials.forEach(function (material) {
                    let rawPre = material.avg_pre_test ? parseFloat(material.avg_pre_test) : 0
                    let rawPost = material.avg_post_test ? parseFloat(material.avg_post_test) : 0
                    let growth = 0

                    try {
                        let rawCalc = rawPost - rawPre

                        growth = Math.round((rawCalc/rawPre) * 100)
                    } catch (e) {
                        growth = 0
                    }

                    data.push({
                        id: num++,
                        is_heading: false,
                        name: material.name,
                        inspirator: material.inspirator,
                        avg_pre_test: material.avg_pre_test,
                        avg_post_test: material.avg_post_test,
                        growth
                    })
                })
            })

            return data
        }
    },
    created() {
        this.getItems()
    },
    data() {
        return {
            loading: false,
            items: null
        }
    },
    methods: {
        getItems() {
            this.loading = true

            this.$http.get(this.routeUri('api.report.classical.exam-growth'))
                .then( (r) => this.items =  r.data)
                .catch((e) => this.handleXhrError(e))
                .finally(() => this.loading = false)
        },
        back() {
            window.location.href = this.routeUri('admin.classical.general.report')
        }
    }
}
</script>
